import React from "react"

export default function Chevron({ disabled }) {
  return (
    <svg width={17} height={11} viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 10L8.5 1 1 10" stroke="#000" strokeOpacity={disabled ? 0.3 : 1} />
    </svg>
  )
}
